import { ReactElement } from 'react';

type LoginErrorMessageProps = {
  error: Error;
};

const shouldShowAdBlockerHint = (message: string): boolean =>
  message.includes('Failed to fetch');

export const LoginErrorMessage = ({
  error,
}: LoginErrorMessageProps): ReactElement => {
  return (
    <>
      <span>{error.message}</span>
      {shouldShowAdBlockerHint(error.message) && (
        <>
          <br />
          <span>
            If you use an ad blocker or privacy extension, allowlist Confidence
            and try again. Some Confidence domains were recently reported on
            blocker lists. If this continues, check VPN or network access, or
            contact support.
          </span>
        </>
      )}
    </>
  );
};
